import { IStaffCategory, IStaffType } from "@/api";
import { useAppSelector } from "@/common/hooks";

export const useStaffCategories = () => {
  return useAppSelector((state) => state.appConfig.staffCategory.staffCategories);
};

export const useStaffCategoryByKey = () => {
  return useAppSelector((state) => state.appConfig.staffCategory.staffCategoriesByKey);
};
type TCategoryByStaffTypeKey = Partial<Record<IStaffType["key"], IStaffCategory>>;
export function useStaffCategoryByStaffTypeKey(): TCategoryByStaffTypeKey;
export function useStaffCategoryByStaffTypeKey(
  staffTypeKey: IStaffType["key"] | undefined,
): IStaffCategory | undefined;
export function useStaffCategoryByStaffTypeKey(
  staffTypeKey?: IStaffType["key"],
): IStaffCategory | undefined | TCategoryByStaffTypeKey {
  const categoryByStaffTypeKey = useAppSelector(
    (state) => state.appConfig.staffCategory.staffCategoryByStaffTypeKey,
  );

  // If staffTypeKey is provided, even if undefined, return one value
  if (staffTypeKey) return categoryByStaffTypeKey[staffTypeKey];
  if (arguments.length === 1) return undefined;

  // Else return the whole object
  return categoryByStaffTypeKey;
}
